import { DocumentView } from '../../../../../../services/RefundService/types/documentTypes';
import { getFileIcon, getFileTypeLabel, formatDate } from '../utils';

export interface DocumentGridRow {
  id: string;
  fileName: string;
  extension: string;
  uploadBy: string;
  uploadDate: string;
  uploadDateFormatted: string;
  fileType: string;
  iconEmoji: string;
  document: DocumentView;
}

/**
 * Transform documents to grid row data
 */
export function transformDocumentsToGridData(documents: DocumentView[]): DocumentGridRow[] {
  return documents
    .filter((doc) => !doc.isDeleted)
    .map((doc) => ({
      id: doc.id,
      fileName: doc.fileName,
      extension: doc.extension,
      uploadBy: doc.uploadedBy || 'Unknown',
      uploadDate: doc.uploadedDate || '',
      uploadDateFormatted: formatDate(doc.uploadedDate),
      fileType: getFileTypeLabel(doc.extension),
      iconEmoji: getFileIcon(doc.extension),
      document: doc,
    }));
}
